export default "__VITE_ASSET__DWQK9KfG__"